import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IPlan } from '../interfaces';
import { PlanMapper } from '../mappers';

export type IGetPlanByIdRepoResponse = IRepoResponse<200, IPlan> | IRepoResponse<400 | 500, string>;

export type IGetPlanByIdRepo = IRepo<[number | string], IGetPlanByIdRepoResponse>;

export const GetPlanByIdRepoType = Symbol.for('GetPlanByIdRepo');

@bind(GetPlanByIdRepoType)
export class GetPlanByIdRepo implements IGetPlanByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/tariff/getinfo', { tariff_id: id }) });

      if (result.status === 200) {
        const data: IPlan = PlanMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
